import { Pipe, PipeTransform } from '@angular/core';
import { LocaleService } from '../../../services/locale.service';

@Pipe({
  name: 'locale',
  pure: false,
  standalone: false
})
export class LocalePipe implements PipeTransform {
  constructor(private localeService: LocaleService) {}

  transform(key: string, upperCase = false): string {
    const text = this.localeService.getString(key);
    if (!upperCase) return text;
    return text.toUpperCase();
  }
}
